import React, { useEffect, useState } from 'react';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { BrandHub } from './pages/BrandHub';
import { Transactions } from './pages/Transactions';
import { Orders } from './pages/Orders';
import { Invoicing } from './pages/Invoicing';
import { Storefront } from './pages/Storefront';
import { Affiliates } from './pages/Affiliates';
import { AppCenter } from './pages/AppCenter';
import { AddProduct } from './pages/AddProduct';
import { Customers } from './pages/Customers';
import { Payouts } from './pages/Payouts';
import { Reports } from './pages/Reports';
import { Pricing } from './pages/Pricing';
import { Login } from './pages/Login';
import { AgentToBoss } from './pages/AgentToBoss';
import { CreatorDashboard } from './pages/CreatorDashboard';
import { SimonsAcquahAgency } from './pages/SimonsAcquahAgency';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');
  useEffect(() => {
    const handleTabChange = (e: any) => setActiveTab(e.detail);
    window.addEventListener('changeTab', handleTabChange);
    return () => window.removeEventListener('changeTab', handleTabChange);
  }, []);
  if (!isAuthenticated) {
    return <Login onLogin={() => setIsAuthenticated(true)} data-id="element-0" />;
  }
  // Full-page views rendered WITHOUT the sidebar/layout
  if (activeTab === 'agenttoboss') {
    return <AgentToBoss onBack={() => setActiveTab('storefront')} data-id="element-1" />;
  }
  if (activeTab === 'creator-dashboard') {
    return <CreatorDashboard onBack={() => setActiveTab('agenttoboss')} data-id="element-2" />;
  }
  if (activeTab === 'simons-acquah') {
    return <SimonsAcquahAgency onBack={() => setActiveTab('storefront')} data-id="element-3" />;
  }
  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard data-id="element-4" />;
      case 'brand-hub':
        return <BrandHub data-id="element-5" />;
      case 'transactions':
        return <Transactions data-id="element-6" />;
      case 'orders':
        return <Orders data-id="element-7" />;
      case 'customers':
        return <Customers data-id="element-8" />;
      case 'payouts':
        return <Payouts data-id="element-9" />;
      case 'pricing':
        return <Pricing data-id="element-10" />;
      case 'invoicing':
        return <Invoicing data-id="element-11" />;
      case 'storefront':
        return <Storefront data-id="element-12" />;
      case 'affiliates':
        return <Affiliates data-id="element-13" />;
      case 'app-center':
        return <AppCenter data-id="element-14" />;
      case 'add-product':
        return <AddProduct data-id="element-15" />;
      case 'reports':
        return <Reports data-id="element-16" />;
      case 'login':
        return <Login onLogin={() => setIsAuthenticated(true)} data-id="element-17" />;
      default:
        return <div className="flex flex-col items-center justify-center h-[60vh] text-slate-400" data-id="element-18">
            <p className="text-lg font-medium" data-id="element-19">
              Section "{activeTab}" is under development
            </p>
            <button onClick={() => setActiveTab('dashboard')} className="mt-4 text-blue-600 font-bold hover:underline" data-id="element-20">
              Back to Dashboard
            </button>
          </div>;
    }
  };
  return <Layout activeTab={activeTab} setActiveTab={setActiveTab} onLogout={() => setIsAuthenticated(false)} data-id="element-21">
      {renderContent()}
    </Layout>;
}